import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Header } from '@/components/generals/header'
import { Footer } from '@/components/generals/footer'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#main'
                className='sr-only z-[70] rounded-full bg-brand px-4 py-2 text-sm font-semibold text-brand-foreground focus:not-sr-only focus:fixed focus:left-4 focus:top-4'
            >
                Skip to content
            </a>

            <Header />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <Footer />
        </div>
    )
}
